// extracted by mini-css-extract-plugin
module.exports = {"CheckboxForCellar":"CheckboxForCellar_CheckboxForCellar__3IVIY","CheckboxForCellarImage":"CheckboxForCellar_CheckboxForCellarImage__Y3bJ6"};